import {User} from '@/model/resource/User'

export class AuthResponse {
  user: User | null = null

  token: string | null = null
}
